import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../services/trackingUserEvents";

// دكشنري لتسمية الصفحات مع دعم dynamic params مثل ":id"
const pageNames = {
  "/": "Home",
  "/store": "Store Page",
  "/news/:page?": "News Page",
  "/user": "User Profile Page",
  "/cp": "Control Panel",
  "/deleteAccount": "Delete Account Page",
  "/offers": "Offers Page",
  "/searchPage": "Search Page",
  "/offers/order/:slug": "Offer Order Page",
  "/offers/detail/:slug": "Offer Details Page",
  "/offers/vehicles/:slug": "Offer Vehicles Page",
  "/offers/type/:type": "Offers By Type Page",
  "/offers/offerServiceReservation/:slug": "Offer Service Reservation Details",
  "/news/detail/:slug": "News Details Page",
  "/orderDraftsCheck/:orderGuid": "Order Drafts Check",
  "/partsReservationCheck/:orderGuid": "Parts Reservation Check",
  "/car/:page/:sn/:slug": "Car Overview Detailed",
  "/carSO/:page/:orderGuid": "Car Sales Order Details",
  "/recruitment/detail/:slug": "Recruitment Details",
  "/recruitment/:page?": "Recruitment Listings",
  "/recruitment/applicationForm/:id": "Job Application Form",
  "/recruitment/interviewAttendance/:id": "Interview Attendance Page",
  "/order-car": "Vehicle Purchase Order",
  "/hj/advises": "HJ Advises Page",
  "/about": "About Us",
  "/maintenance": "Maintenance Main Page",
  "/maintenance/service/:CATid": "Maintenance Service Category",
  "/maintenance/service/detail/:ServicId": "Maintenance Service Details",
  "/maintenance/order-service/:service": "Maintenance Order Service",
  "/contact": "Contact Us",
  "/finance": "Finance Main Page",
  "/finance/detail": "Finance Details",
  "/finance/order": "Finance Order Page",
  "/cart": "Shopping Cart",
  "/paymentPage": "Checkout Payment Page",
  "/purchaseMsg/:id": "Purchase Status Alert",
  "/parts": "Spare Parts Store",
  "/toyotaPartsPage": "Toyota Parts Filter",
  "/vehicles/:brand": "Vehicles By Brand",
  "/VehicleOnline": "Online Vehicle Store",
  "/compare": "Vehicles Compare Page",
  "/vehicles/:brand/:group/:year": "Vehicle Details Page",
  "/vehicles/:brand/:group/:year/:section": "Vehicle Section Details",
  "/vehicles/:brand/:group/:year/:section/:modelslug": "Vehicle Model Details",
  "/SalesOrders/DeliveryScheduling/:sn/:vehicleUser": "Delivery Scheduling Page",
  "/search": "General Search Results",
  "/privacy": "Privacy Policy",
  "/websitePolicy": "Website Use Policy",
  "/agreement": "Sales Agreement Page",
  "/protectionAndShadingAgreement": "Protection and Shading Agreement",
  "/landengPage": "Brand Landing Page",
  "/landengPage/:pageID": "Landing Page Detail",
  "/NewsPage/:page?": "Dynamic News Page",
  "/r/:page?": "Redirect Handler",
};

// دالة لتحويل pathPattern مثل "/offers/detail/:slug" إلى regex
const pathToRegex = (pathPattern) => {
  // Replace ? (optional) with (?:/([^/]+))? or similar, but simpler is better for now
  // For :page?, let's handle it manually or improve regex
  const regexString = "^" + pathPattern
    .replace(/\/:[^/]+\?/g, "(?:/([^/]+))?") // Handle optional params like :page?
    .replace(/:[^/]+/g, "([^/]+)") + "$"; // Handle required params
  return new RegExp(regexString);
};

const RouteTracker = ({ debounceTime = 3000 }) => {
  const location = useLocation();
  const lastPageRef = useRef({ path: null, timestamp: 0 });

  useEffect(() => {
    const now = Date.now();
    const path = location.pathname;

    // تجاهل الإرسال إذا نفس الصفحة خلال فترة debounceTime
    if (
      lastPageRef.current.path === path &&
      now - lastPageRef.current.timestamp < debounceTime
    ) return;

    lastPageRef.current = { path, timestamp: now };

    // البحث عن مفتاح يطابق path بدقة
    let pageName = path; // fallback
    for (const key in pageNames) {
      const regex = pathToRegex(key);
      if (regex.test(path)) {
        pageName = pageNames[key];
        break;
      }
    }

    trackPageView(pageName, path);
  }, [location, debounceTime]);

  return null;
};

export default RouteTracker;
